import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IBindBaseEntity} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchPillarsThunk: any = createAsyncThunk<IBindBaseEntity[]>(
  `${prefix} fetchPillars`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getActivePillars();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch pillars. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
